/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconSteps/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconSteps({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconSteps",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 20,
  height = 20,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9883D4",
  fill3 = "#fff"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconSteps.Svg"
  data-view-path={viewPath}
 viewBox="0 0 20 20"
 style={{'--as-1-n4Eaz': alignSelf,'--mt-2-n4Eaz': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-n4Eaz': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-n4Eaz': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-n4Eaz': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-n4Eaz': opacity,'--w-10-n4Eaz': typeof width === 'number' ? `${width}px` : width,'--h-11-n4Eaz': typeof height === 'number' ? `${height}px` : height,'--f-12-n4Eaz': fill,'--a-7-n4Eaz': isAnimated ? animation : "none",'--sd-8-n4Eaz': isAnimated ? strokeDashoffset : 0,'--sd-9-n4Eaz': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconSteps.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4.5 3A1.5 1.5 0 003 4.5v11A1.5 1.5 0 004.5 17h11a1.5 1.5 0 001.5-1.5v-11A1.5 1.5 0 0015.5 3h-11z"
 style={{'--f-12-n4Eaz': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="TysiaIconSteps.SvgPath:1"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M10 8c-.96 0-1.772.63-2.045 1.5h-1.1a1.5 1.5 0 100 1.286h1.1a2.144 2.144 0 004.09 0h1.1a1.5 1.5 0 100-1.286h-1.1A2.144 2.144 0 0010 8z"
 style={{'--f-12-n4Eaz': fill3}}
 className={`views-block ${styles.SvgPath1}`}
/>
</svg>
{children}
</React.Fragment>)
}